<template>
    <div class="sidebar">
        <div class="sidebar-header gap-3">
            <a href="javascript:void(0)" class="sidebar-logo"><img src="assets/img/hassan_police_logo.jpeg" class="img" width="40" height="40" /></a>
            <div>
                <a class="text-dark header-logo mb-0 mt-3">Muddemal</a>
                <p class="fs-12 font-gray">Hassan City Police</p>
            </div>
        </div>
        <div id="sidebarMenu" class="sidebar-body ps">
            <div class="nav-group show">
                <a href="javascript:void(0)" class="nav-label"><i class="ri-group-line me-2 menu_icon"></i> Main</a>
                <ul class="nav nav-sidebar">
                    <!-- <li class="nav-item">
                        <router-link to="/dashboard" class="nav-link"><i class="ri-add-box-line"></i> <span>Dashboard</span></router-link>
                    </li> -->
                    <li class="nav-item">
                        <router-link to="/muddemal" class="nav-link"><i class="ri-file-list-3-line"></i> <span>Muddemal</span></router-link>
                    </li>
                    <li class="nav-item" v-if="showAdminUI">
                        <router-link to="/users" class="nav-link"><i class="ri-group-line"></i><span>User Management</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/logs" class="nav-link"><i class="ri-download-2-line"></i><span>Downloads</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/downloaded_qr_codes" class="nav-link"><i class="ri-qr-code-line"></i><span>Downloaded QR Codes</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="nav-group" :class="{ 'show': configOpen }" v-if="showAdminUI">
                <a href="javascript:void(0)" class="nav-label" @click="toggleConfig"><i class="ri-settings-5-line me-2 menu_icon"></i> Configuration</a>
                <ul class="nav nav-sidebar">
                    <li class="nav-item">
                        <router-link to="/sub_divisions" class="nav-link"><i class="ri-building-4-line"></i><span>Sub Divisions</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/circles" class="nav-link"><i class="ri-map-pin-line"></i><span>Circles</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/police_stations" class="nav-link"><i class="ri-home-8-fill"></i><span>Police Stations</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/case_stages" class="nav-link"><i class="ri-bar-chart-2-line"></i><span>Case Stages</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/property_types" class="nav-link"><i class="ri-pie-chart-line"></i><span>Property Types</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/property_disposal_stages" class="nav-link"><i class="ri-bar-chart-horizontal-fill"></i><span>Property Disposal Stages</span></router-link>
                    </li>

                </ul>
            </div>
            <div class="nav-group show">
                <a href="javascript:void(0)" class="nav-label"><i class="ri-file-chart-line me-2 menu_icon"></i> Reports</a>
                <ul class="nav nav-sidebar">
                    <li class="nav-item">
                        <router-link to="/audit_report" class="nav-link"><i class="ri-file-chart-line"></i><span>Audit Report</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/audit_report_year_wise" class="nav-link"><i class="ri-calendar-check-line"></i><span>Audit Report Year Wise</span></router-link>
                    </li>
                    <li class="nav-item" v-if="showAdminUI">
                        <router-link to="/property_details_report" class="nav-link"><i class="ri-government-line"></i><span>Property Details</span></router-link>
                    </li>
                    <li class="nav-item" v-if="showAdminUI">
                        <router-link to="/cases_status_report" class="nav-link"><i class="ri-suitcase-line"></i><span>Cases Status Year Wise</span></router-link>
                    </li>
                    <li class='nav-item'>
                        <router-link to="/analytics" class="nav-link"><i class="ri-government-line"></i><span>Analytics</span></router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="sidebar-footer">
            <div class="sidebar-footer-top" id="sidebarFooterMenu">
                <div class="sidebar-footer-thumb">
                    <!-- <img src="assets/img/bg1.jpg" alt="" /> -->
                    <img v-if="$store.getters?.user?.avatar" :src="$store.getters?.user?.avatar" alt="User Image" />
                    <img v-else src="assets/img/bg1.jpg" alt="User Image" />
                </div>
                <div class="sidebar-footer-body">
                    <h6><a href="javascript:void(0)">{{ $store.getters.user.name }}</a></h6>
                    <p>{{ $store.getters.user.role }}</p>
                </div>
                <a id="sidebarFooterMenu" href="javascript:void(0)" class="dropdown-link"><i class="ri-arrow-down-s-line"></i></a>
            </div>
            <div class="sidebar-footer-menu">
                <nav class="nav">
                    <router-link to="/profile_update"><i class="ri-user-line"></i> Edit Profile</router-link>
                    <!-- <a href="javascript:void(0)"><i class="ri-edit-2-line"></i> Edit Profile</a> -->
                    <a href="javascript:void(0)" @click="logout()"><i class="ri-logout-box-r-line"></i> Log Out</a>
                </nav>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data() {
            return {
                configOpen: false, // Track if Configuration dropdown is open
                isAdminValidated: false // Track if admin status has been validated with server
            }
        },
        async mounted() {
            // Validate admin status with server before showing any admin UI
            // This prevents UI exposure even if client-side flag is manipulated
            if (this.$store.getters.token && this.$store.getters.user) {
                try {
                    const isAdmin = await this.$store.dispatch('validateAdminAccess');
                    this.isAdminValidated = true;
                    
                    if (isAdmin) {
                        // Only open Configuration if server confirms admin status
                        this.configOpen = true;
                    }
                } catch (error) {
                    console.error('Admin validation failed:', error);
                    // Fail secure - don't show admin UI
                    this.isAdminValidated = false;
                }
            }
        },
        watch: {
            // Watch for changes in isAdmin and validate with server before showing UI
            '$store.getters.isAdmin': async function(newVal) {
                // Re-validate with server before showing admin UI
                if (newVal && this.$store.getters.token) {
                    try {
                        const isAdmin = await this.$store.dispatch('validateAdminAccess');
                        if (isAdmin) {
                            this.configOpen = true;
                        } else {
                            // Server says not admin - hide UI even if flag was manipulated
                            this.configOpen = false;
                        }
                    } catch (error) {
                        // On error, hide admin UI (fail secure)
                        this.configOpen = false;
                    }
                } else {
                    this.configOpen = false;
                }
            }
        },
        computed: {
            // Only show admin UI if validated by server
            showAdminUI() {
                return this.isAdminValidated && this.$store.getters.isAdmin;
            }
        },
        methods: {
            toggleConfig() {
                this.configOpen = !this.configOpen;
                console.log('Configuration dropdown toggled:', this.configOpen);
            },
            async logout(){
                try {
                    const response = await this.$store.dispatch('post',{uri: 'logout'});
                    this.$store.dispatch('success', response.data.message);
                } catch (error) {
                    this.$store.dispatch('error', error.response?.data?.message || 'Logout failed on server. Logging out locally.');
                } finally {
                    await this.$store.dispatch('logout');
                    const pathname = window.location.pathname || '/';
                    const basePath = pathname.endsWith('/')
                        ? pathname
                        : pathname.substring(0, pathname.lastIndexOf('/') + 1);
                    window.location.replace(basePath + '#/');
                }
            }
        }
    }
</script>
<style scoped>
    .ml-20 {
        margin-left: 20px;
    }
    .menu_icon {
        font-size: 20px;
        opacity: 0.85;
    }
</style>
